import {toast} from "react-toastify";

export const formatToCamelCase = text => {
  let capitalizedText = text.charAt(0)?.toUpperCase() + text.slice(1);
  return capitalizedText.replace('_', ' ');
};

export const checkFileExtension = fileName => {
  if (fileName?.length > 0) {
    let fileArray = fileName?.split('.');
    return fileArray[fileArray?.length - 1];
  }
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const copyText = (message, copiedText) => {
  navigator.clipboard.writeText(copiedText)
      .then(() => {
        toast.success(`${message} ${copiedText} `);
      })
      .catch((err) => {
          toast.error('Failed to copy:', err);
      });
};